import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

const InfoSection = ({
    title,
    icon,
    children,
    isEditing = false,
    isLoading = false,
    hasError = false,
    onEdit,
    onSave,
    onCancel
}) => {
    return (
        <div className="tw-mb-4 tw-rounded-xl tw-bg-white tw-border tw-border-slate-100 tw-shadow-sm tw-overflow-hidden tw-h-full tw-flex tw-flex-col">
            {/* Header */}
            <div className="tw-px-5 tw-py-3 tw-border-b tw-border-slate-100 tw-flex tw-items-center tw-justify-between tw-bg-gradient-to-r tw-from-slate-50 tw-to-white">
                <div className="tw-flex tw-items-center tw-gap-2">
                    {icon && (
                        <div className="tw-w-8 tw-h-8 tw-rounded-lg tw-bg-amber-100 tw-flex tw-items-center tw-justify-center">
                            <Icon icon={icon} className="tw-text-lg tw-text-amber-600" />
                        </div>
                    )}
                    <h3 className="tw-text-sm tw-font-semibold tw-text-slate-700">
                        {title}
                    </h3>
                </div>
                <div className="tw-flex tw-items-center tw-gap-2">
                    {isEditing ? (
                        <>
                            <button
                                type="button"
                                onClick={onCancel}
                                disabled={isLoading}
                                className="tw-flex tw-items-center tw-gap-1 tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-slate-600 tw-bg-slate-100 tw-text-xs tw-font-medium hover:tw-bg-slate-200 tw-transition-colors disabled:tw-opacity-50"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={onSave}
                                disabled={isLoading || hasError}
                                className="tw-flex tw-items-center tw-gap-1 tw-px-3 tw-py-1.5 tw-rounded-lg tw-bg-amber-500 tw-text-white tw-text-xs tw-font-medium hover:tw-bg-amber-600 tw-transition-colors disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                            >
                                {isLoading ? (
                                    <>
                                        <div className="tw-w-3 tw-h-3 tw-border-2 tw-border-white tw-border-t-transparent tw-rounded-full tw-animate-spin"></div>
                                        Saving...
                                    </>
                                ) : (
                                    <>
                                        <Icon icon="solar:check-circle-bold" className="tw-text-sm" />
                                        Save
                                    </>
                                )}
                            </button>
                        </>
                    ) : (
                        <button
                            type="button"
                            onClick={onEdit}
                            className="tw-flex tw-items-center tw-gap-1 tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-amber-600 tw-bg-amber-50 tw-text-xs tw-font-medium hover:tw-bg-amber-100 tw-transition-colors"
                        >
                            <Icon icon="solar:pen-bold" className="tw-text-sm" />
                            Edit
                        </button>
                    )}
                </div>
            </div>
            {/* Body */}
            <div className="tw-px-4 tw-py-3 tw-flex-1">
                {children}
            </div>
        </div>
    );
};

export default InfoSection;
